var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "hello" },
    [
      _c("div", { staticClass: "titleTotal" }, [
        _c("div", { staticClass: "grid" }, [
          _c("p", { on: { click: _vm.addCustom } }, [
            _c("img", {
              attrs: { src: require("../../assets/header.png"), alt: "" },
            }),
            _c("span", [_vm._v("添加客户")]),
          ]),
          _c(
            "p",
            {
              staticStyle: { "margin-top": "30px" },
              on: { click: _vm.queryCus },
            },
            [
              _c("img", {
                attrs: { src: require("../../assets/search.png"), alt: "" },
              }),
              _c("span", [_vm._v("查询客户")]),
            ]
          ),
        ]),
        _vm.parArray.indexOf("wdsjbb") != -1
          ? _c("div", { staticClass: "dataDisplay" }, [
              _c("div", { staticClass: "header" }, [
                _vm._m(0),
                _c(
                  "div",
                  { staticClass: "top_right" },
                  [
                    _c(
                      "div",
                      { staticClass: "selectTree" },
                      [
                        _c("treeselect", {
                          attrs: {
                            options: _vm.options,
                            "search-nested": "",
                            normalizer: _vm.normalizer,
                            noResultsText: "未找到",
                            placeholder: "请选择",
                          },
                          model: {
                            value: _vm.orgNameTop,
                            callback: function ($$v) {
                              _vm.orgNameTop = $$v
                            },
                            expression: "orgNameTop",
                          },
                        }),
                      ],
                      1
                    ),
                    _c("el-date-picker", {
                      attrs: {
                        type: "daterange",
                        "picker-options": _vm.pickerOptions2,
                        "unlink-panels": "",
                        "range-separator": "至",
                        "start-placeholder": "开始日期",
                        "end-placeholder": "结束日期",
                        align: "right",
                        format: "yyyy- MM- dd",
                        "value-format": "yyyy-MM-dd",
                      },
                      model: {
                        value: _vm.value4,
                        callback: function ($$v) {
                          _vm.value4 = $$v
                        },
                        expression: "value4",
                      },
                    }),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "mini" },
                        on: { click: _vm.refleshTop },
                      },
                      [_vm._v("刷新")]
                    ),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "colDate" }, [
                _c("div", { staticClass: "col" }, [
                  _c("p", [_vm._v("下单总金额")]),
                  _vm.myData.totalMoney
                    ? _c(
                        "div",
                        [
                          _c("count-to", {
                            staticClass: "card-panel-num",
                            attrs: {
                              "start-val": 0,
                              "end-val": Number(_vm.myData.totalMoney),
                              duration: 2600,
                            },
                          }),
                        ],
                        1
                      )
                    : _c("div", [_vm._v(_vm._s(_vm.myData.totalMoney))]),
                  _c("div", { staticClass: "contrast" }, [
                    _c("span", [_vm._v("较昨日")]),
                    Number(_vm.myData.totalMoneyGrowthRate) > 0
                      ? _c("img", {
                          attrs: {
                            src: require("../../assets/ss.png"),
                            alt: "",
                          },
                        })
                      : _c("img", {
                          attrs: {
                            src: require("../../assets/xj.png"),
                            alt: "",
                          },
                        }),
                    _vm.myData.totalMoneyGrowthRate
                      ? _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.myData.totalMoneyGrowthRate.replace(
                                /[&\|\\\*^%$#@\-]/g,
                                ""
                              ) + "%"
                            )
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ]),
                _c("div", { staticClass: "col" }, [
                  _c("p", [_vm._v("下单订单总数")]),
                  _vm.myData.successOrderTotal
                    ? _c(
                        "div",
                        [
                          _c("count-to", {
                            staticClass: "card-panel-num",
                            attrs: {
                              "start-val": 0,
                              "end-val": Number(_vm.myData.successOrderTotal),
                              duration: 2600,
                            },
                          }),
                        ],
                        1
                      )
                    : _c("div", [_vm._v(_vm._s(_vm.myData.successOrderTotal))]),
                  _c("div", { staticClass: "contrast" }, [
                    _c("span", [_vm._v("较昨日")]),
                    Number(_vm.myData.successOrderTotalGrowthRate) > 0
                      ? _c("img", {
                          attrs: {
                            src: require("../../assets/ss.png"),
                            alt: "",
                          },
                        })
                      : _c("img", {
                          attrs: {
                            src: require("../../assets/xj.png"),
                            alt: "",
                          },
                        }),
                    _vm.myData.successOrderTotalGrowthRate
                      ? _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.myData.successOrderTotalGrowthRate.replace(
                                /[&\|\\\*^%$#@\-]/g,
                                ""
                              ) + "%"
                            )
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ]),
                _c("div", { staticClass: "col" }, [
                  _c("p", [_vm._v("代收总金额")]),
                  _vm.myData.pendingTotalMoney
                    ? _c(
                        "div",
                        [
                          _c("count-to", {
                            staticClass: "card-panel-num",
                            attrs: {
                              "start-val": 0,
                              "end-val": Number(_vm.myData.pendingTotalMoney),
                              duration: 2600,
                            },
                          }),
                        ],
                        1
                      )
                    : _c("div", [_vm._v(_vm._s(_vm.myData.pendingTotalMoney))]),
                  _c("div", { staticClass: "contrast" }, [
                    _c("span", [_vm._v("较昨日")]),
                    Number(_vm.myData.pendingTotalMoneyGrowthRate) > 0
                      ? _c("img", {
                          attrs: {
                            src: require("../../assets/ss.png"),
                            alt: "",
                          },
                        })
                      : _c("img", {
                          attrs: {
                            src: require("../../assets/xj.png"),
                            alt: "",
                          },
                        }),
                    _vm.myData.pendingTotalMoneyGrowthRate
                      ? _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.myData.pendingTotalMoneyGrowthRate.replace(
                                /[&\|\\\*^%$#@\-]/g,
                                ""
                              ) + "%"
                            )
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ]),
                _c("div", { staticClass: "col" }, [
                  _c("p", [_vm._v("代收订单总数")]),
                  _vm.myData.pendingTotalOrderNumber
                    ? _c(
                        "div",
                        [
                          _c("count-to", {
                            staticClass: "card-panel-num",
                            attrs: {
                              "start-val": 0,
                              "end-val": Number(
                                _vm.myData.pendingTotalOrderNumber
                              ),
                              duration: 2600,
                            },
                          }),
                        ],
                        1
                      )
                    : _c("div", [
                        _vm._v(_vm._s(_vm.myData.pendingTotalOrderNumber)),
                      ]),
                  _c("div", { staticClass: "contrast" }, [
                    _c("span", [_vm._v("较昨日")]),
                    Number(_vm.myData.pendingTotalOrderNumberGrowthRate) > 0
                      ? _c("img", {
                          attrs: {
                            src: require("../../assets/ss.png"),
                            alt: "",
                          },
                        })
                      : _c("img", {
                          attrs: {
                            src: require("../../assets/xj.png"),
                            alt: "",
                          },
                        }),
                    _vm.myData.pendingTotalOrderNumberGrowthRate
                      ? _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.myData.pendingTotalOrderNumberGrowthRate.replace(
                                /[&\|\\\*^%$#@\-]/g,
                                ""
                              ) + "%"
                            )
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ]),
                _c("div", { staticClass: "col" }, [
                  _c("p", [_vm._v("占比")]),
                  _vm.myData.totalMoneyPercentage
                    ? _c(
                        "div",
                        [
                          _c("count-to", {
                            staticClass: "card-panel-num",
                            attrs: {
                              "start-val": 0,
                              "end-val": Number(
                                _vm.myData.totalMoneyPercentage
                              ),
                              duration: 2600,
                            },
                          }),
                        ],
                        1
                      )
                    : _c("div", [
                        _vm._v(_vm._s(_vm.myData.totalMoneyPercentage)),
                      ]),
                  _c("div", { staticClass: "contrast" }, [
                    _c("span", [_vm._v("较昨日")]),
                    Number(_vm.myData.totalMoneyPercentageGrowthRate) > 0
                      ? _c("img", {
                          attrs: {
                            src: require("../../assets/ss.png"),
                            alt: "",
                          },
                        })
                      : _c("img", {
                          attrs: {
                            src: require("../../assets/xj.png"),
                            alt: "",
                          },
                        }),
                    _vm.myData.totalMoneyPercentageGrowthRate
                      ? _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.myData.totalMoneyPercentageGrowthRate.replace(
                                /[&\|\\\*^%$#@\-]/g,
                                ""
                              ) + "%"
                            )
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ]),
              ]),
            ])
          : _vm._e(),
      ]),
      _c("div", { staticClass: "dataTeamplete" }, [
        _c("div", [
          _c("div", { staticClass: "header" }, [
            _vm._m(1),
            _c(
              "div",
              { staticClass: "top_right" },
              [
                _c(
                  "div",
                  { staticClass: "selectTree" },
                  [
                    _c("treeselect", {
                      attrs: {
                        options: _vm.options,
                        "search-nested": "",
                        normalizer: _vm.normalizer,
                        multiple: true,
                        noResultsText: "未找到",
                        placeholder: "请选择",
                      },
                      model: {
                        value: _vm.rinkForm.colony,
                        callback: function ($$v) {
                          _vm.$set(_vm.rinkForm, "colony", $$v)
                        },
                        expression: "rinkForm.colony",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "picker_select" },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          clearable: "",
                          filterable: "",
                          placeholder: "请选择",
                        },
                        model: {
                          value: _vm.rinkForm.salasType,
                          callback: function ($$v) {
                            _vm.$set(_vm.rinkForm, "salasType", $$v)
                          },
                          expression: "rinkForm.salasType",
                        },
                      },
                      _vm._l(_vm.statistic, function (items) {
                        return _c("el-option", {
                          key: items.dictId,
                          attrs: { label: items.dictName, value: items.dictId },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c("el-date-picker", {
                  attrs: {
                    type: "daterange",
                    "picker-options": _vm.pickerOptions2,
                    "unlink-panels": "",
                    "range-separator": "至",
                    "start-placeholder": "开始日期",
                    "end-placeholder": "结束日期",
                    align: "right",
                    format: "yyyy- MM- dd",
                    "value-format": "yyyy-MM-dd",
                  },
                  model: {
                    value: _vm.rinkForm.time,
                    callback: function ($$v) {
                      _vm.$set(_vm.rinkForm, "time", $$v)
                    },
                    expression: "rinkForm.time",
                  },
                }),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "mini" },
                    on: { click: _vm.refleshSalas },
                  },
                  [_vm._v("刷新")]
                ),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "graphical" }, [
            _c("div", { staticClass: "group" }, [
              _c("div", { staticClass: "groupTitle" }, [
                _c(
                  "div",
                  { staticClass: "checked" },
                  [
                    _c(
                      "el-radio-group",
                      {
                        on: { change: _vm.changTu },
                        model: {
                          value: _vm.checkedTu,
                          callback: function ($$v) {
                            _vm.checkedTu = $$v
                          },
                          expression: "checkedTu",
                        },
                      },
                      [
                        _c("el-radio", { attrs: { label: 1 } }, [
                          _vm._v("折线图"),
                        ]),
                        _c("el-radio", { attrs: { label: 2 } }, [
                          _vm._v("柱状图"),
                        ]),
                      ],
                      1
                    ),
                    _vm.checkedTu != 2
                      ? _c(
                          "el-radio-group",
                          {
                            on: { change: _vm.dayMothon },
                            model: {
                              value: _vm.checked,
                              callback: function ($$v) {
                                _vm.checked = $$v
                              },
                              expression: "checked",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: 1 } }, [
                              _vm._v("按天展示"),
                            ]),
                            _c("el-radio", { attrs: { label: 2 } }, [
                              _vm._v("按月展示"),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _c(
                  "p",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.teamEvent()
                      },
                    },
                  },
                  [_c("span", [_vm._v("查看详情 >")])]
                ),
              ]),
              _c("div", { staticClass: "echart1" }, [
                _c("div", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.checkedTu == "1",
                      expression: "checkedTu == '1'",
                    },
                  ],
                  staticStyle: { width: "100%", height: "300px" },
                  attrs: { id: "bumen" },
                }),
                _c("div", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.checkedTu == "2",
                      expression: "checkedTu == '2'",
                    },
                  ],
                  staticStyle: { width: "100%", height: "300px" },
                  attrs: { id: "bumenZZ" },
                }),
              ]),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "group", staticStyle: { width: "25%" } }, [
          _c("div", { staticClass: "groupTitle" }, [
            _c("p", [_vm._v("员工排行榜")]),
            _c("p", { on: { click: _vm.employeeRankingClick } }, [
              _c("span", [_vm._v("查看更多 >")]),
            ]),
          ]),
          _c(
            "ul",
            { staticClass: "ol", staticStyle: { "min-width": "200px" } },
            _vm._l(_vm.employeeData, function (items, index) {
              return _c("li", { key: index }, [
                _c("p", [
                  _c("span", [_vm._v(_vm._s(index + 1))]),
                  _vm._v(_vm._s(items.label) + " "),
                ]),
                _c("span", [_vm._v(_vm._s(items.value))]),
              ])
            }),
            0
          ),
        ]),
      ]),
      _c("div", { staticClass: "basicInfo" }, [
        _c("div", { staticClass: "header" }, [
          _vm._m(2),
          _c(
            "div",
            { staticClass: "top_right" },
            [
              _c(
                "div",
                { staticClass: "selectTree" },
                [
                  _c("treeselect", {
                    attrs: {
                      options: _vm.options,
                      "search-nested": "",
                      normalizer: _vm.normalizer,
                      noResultsText: "未找到",
                      placeholder: "请选择",
                    },
                    model: {
                      value: _vm.userPortraitSearch.orgCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.userPortraitSearch, "orgCode", $$v)
                      },
                      expression: "userPortraitSearch.orgCode",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "picker_select" },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        clearable: "",
                        filterable: "",
                        placeholder: "请选择",
                      },
                      model: {
                        value: _vm.userPortraitSearch.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.userPortraitSearch, "type", $$v)
                        },
                        expression: "userPortraitSearch.type",
                      },
                    },
                    _vm._l(_vm.statistic, function (items) {
                      return _c("el-option", {
                        key: items.dictId,
                        attrs: { label: items.dictName, value: items.dictId },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c("el-date-picker", {
                attrs: {
                  type: "daterange",
                  "picker-options": _vm.pickerOptions2,
                  "unlink-panels": "",
                  "range-separator": "至",
                  "start-placeholder": "开始日期",
                  "end-placeholder": "结束日期",
                  align: "right",
                  format: "yyyy- MM- dd",
                  "value-format": "yyyy-MM-dd",
                },
                model: {
                  value: _vm.userPortraitSearch.time,
                  callback: function ($$v) {
                    _vm.$set(_vm.userPortraitSearch, "time", $$v)
                  },
                  expression: "userPortraitSearch.time",
                },
              }),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: { click: _vm.refleshUser },
                },
                [_vm._v("刷新")]
              ),
            ],
            1
          ),
        ]),
        _c("ul", { staticClass: "baseInformation" }, [
          _vm.parArray.indexOf("khdqbb") != -1
            ? _c("li", { staticClass: "float-left" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.huaxiang,
                        expression: "huaxiang",
                      },
                    ],
                    staticClass: "group1",
                  },
                  [
                    _c("div", { staticClass: "groupTitle" }, [
                      _c("p", [_vm._v("地域")]),
                      _c(
                        "p",
                        {
                          staticStyle: { "margin-right": "10px" },
                          on: {
                            click: function ($event) {
                              return _vm.mapEvent()
                            },
                          },
                        },
                        [_c("span", [_vm._v("查看更多 >")])]
                      ),
                    ]),
                    _vm._m(3),
                  ]
                ),
              ])
            : _vm._e(),
          _vm.parArray.indexOf("khrxfsbb") != -1
            ? _c("li", { staticClass: "float-left" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.linedata,
                        expression: "linedata",
                      },
                    ],
                    staticClass: "group1",
                  },
                  [
                    _c("div", { staticClass: "groupTitle" }, [
                      _c("p", [_vm._v("入线方式")]),
                      _c(
                        "p",
                        {
                          staticStyle: { "margin-right": "10px" },
                          on: {
                            click: function ($event) {
                              return _vm.lineEvent()
                            },
                          },
                        },
                        [_c("span", [_vm._v("查看更多 > ")])]
                      ),
                    ]),
                    _vm._m(4),
                  ]
                ),
              ])
            : _vm._e(),
          _vm.parArray.indexOf("khnlbb") != -1
            ? _c("li", { staticClass: "float-left" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.ageData,
                        expression: "ageData",
                      },
                    ],
                    staticClass: "group1",
                  },
                  [
                    _c("div", { staticClass: "groupTitle" }, [
                      _c("p", [_vm._v("年龄")]),
                      _c(
                        "p",
                        {
                          staticStyle: { "margin-right": "10px" },
                          on: {
                            click: function ($event) {
                              return _vm.agoEvent()
                            },
                          },
                        },
                        [_c("span", [_vm._v("查看更多 >")])]
                      ),
                    ]),
                    _vm._m(5),
                  ]
                ),
              ])
            : _vm._e(),
          _vm.parArray.indexOf("khxbbb") != -1
            ? _c("li", { staticClass: "float-left" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.sexData,
                        expression: "sexData",
                      },
                    ],
                    staticClass: "group1",
                  },
                  [
                    _c("div", { staticClass: "groupTitle" }, [
                      _c("p", [_vm._v("性别")]),
                      _c(
                        "p",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.sexEvent()
                            },
                          },
                        },
                        [_c("span", [_vm._v("查看更多 >")])]
                      ),
                    ]),
                    _vm._m(6),
                  ]
                ),
              ])
            : _vm._e(),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "dialogEmployeePopUp" },
        [
          _c(
            "el-dialog",
            {
              attrs: {
                visible: _vm.employeePopUp,
                "append-to-body": true,
                title: "",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.employeePopUp = $event
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "dialog" },
                [
                  _c("div", { staticClass: "header dialogNav" }, [
                    _c("p", [
                      _c("span", { staticStyle: { "font-size": "15px" } }, [
                        _vm._v("员工排行榜"),
                      ]),
                    ]),
                    _c(
                      "div",
                      { staticClass: "top_right" },
                      [
                        _c(
                          "div",
                          { staticClass: "selectTree" },
                          [
                            _c("treeselect", {
                              attrs: {
                                options: _vm.options,
                                searchable: "",
                                normalizer: _vm.normalizer,
                                noResultsText: "未找到",
                                placeholder: "请选择",
                              },
                              model: {
                                value: _vm.employeeForm.colony,
                                callback: function ($$v) {
                                  _vm.$set(_vm.employeeForm, "colony", $$v)
                                },
                                expression: "employeeForm.colony",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "picker" },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  clearable: "",
                                  filterable: "",
                                  placeholder: "请选择数据类型",
                                },
                                model: {
                                  value: _vm.employeeForm.salasType,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.employeeForm, "salasType", $$v)
                                  },
                                  expression: "employeeForm.salasType",
                                },
                              },
                              _vm._l(_vm.statistic, function (items) {
                                return _c("el-option", {
                                  key: items.dictId,
                                  attrs: {
                                    label: items.dictName,
                                    value: items.dictId,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                        _c("el-date-picker", {
                          attrs: {
                            type: "daterange",
                            "picker-options": _vm.pickerOptions2,
                            "unlink-panels": "",
                            "range-separator": "至",
                            "start-placeholder": "开始日期",
                            "end-placeholder": "结束日期",
                            align: "right",
                            format: "yyyy- MM- dd",
                            "value-format": "yyyy-MM-dd",
                          },
                          model: {
                            value: _vm.employeeForm.time,
                            callback: function ($$v) {
                              _vm.$set(_vm.employeeForm, "time", $$v)
                            },
                            expression: "employeeForm.time",
                          },
                        }),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary", size: "mini" },
                            on: { click: _vm.refleshBigEmploy },
                          },
                          [_vm._v("刷新")]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c(
                    "vxe-table",
                    {
                      ref: "xTable",
                      staticClass: "xtable",
                      attrs: {
                        height: "450px",
                        width: "100%",
                        id: "tableData",
                        align: "center",
                        data: _vm.employeeData1.list,
                        "cell-style": _vm.columnStyle,
                      },
                    },
                    [
                      _c("vxe-table-column", {
                        attrs: { title: "序号", field: "rowNum", width: "50" },
                      }),
                      _c("vxe-table-column", {
                        attrs: {
                          title: "员工名称",
                          field: "label",
                          "min-width": "120px",
                        },
                      }),
                      _c("vxe-table-column", {
                        attrs: {
                          "min-width": "120px",
                          title: "职位",
                          field: "positionName",
                        },
                      }),
                      _c("vxe-table-column", {
                        attrs: {
                          "min-width": "120px",
                          title: _vm.title,
                          field: "value",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "page" }, [
                    _c(
                      "div",
                      { staticClass: "block" },
                      [
                        _c("el-pagination", {
                          attrs: {
                            "current-page": _vm.pageNo,
                            "page-sizes": [10, 20, 50, 100, 200],
                            "page-size": _vm.pageSize,
                            layout: "total, sizes, prev, pager, next, jumper",
                            total: _vm.employeeData1.totalNum,
                            "prev-text": "上一页",
                            "next-text": "下一页",
                          },
                          on: {
                            "size-change": _vm.handleSizeChange,
                            "current-change": _vm.handleCurrentChange,
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticStyle: { "min-width": "500px" },
          attrs: {
            visible: _vm.regionPopUp,
            "append-to-body": true,
            title: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.regionPopUp = $event
            },
          },
        },
        [
          _c("div", { staticClass: "dialog" }, [
            _c("div", { staticClass: "header dialogNav" }, [
              _c("p", { staticStyle: { "min-width": "90px" } }, [
                _c("span", { staticStyle: { "font-size": "15px" } }, [
                  _vm._v("区域分布图"),
                ]),
              ]),
              _c(
                "div",
                {
                  staticClass: "top_right",
                  staticStyle: { "min-width": "750px" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "selectTree" },
                    [
                      _c("el-cascader", {
                        attrs: {
                          options: _vm.options,
                          props: {
                            checkStrictly: true,
                            label: "orgName",
                            value: "orgCode",
                            children: "children",
                          },
                          clearable: "",
                          filterable: "",
                        },
                        model: {
                          value: _vm.regionForm.colony,
                          callback: function ($$v) {
                            _vm.$set(_vm.regionForm, "colony", $$v)
                          },
                          expression: "regionForm.colony",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "picker_select" },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            clearable: "",
                            filterable: "",
                            placeholder: "请选择查询类型",
                          },
                          model: {
                            value: _vm.regionForm.salasType,
                            callback: function ($$v) {
                              _vm.$set(_vm.regionForm, "salasType", $$v)
                            },
                            expression: "regionForm.salasType",
                          },
                        },
                        _vm._l(_vm.statistic, function (items) {
                          return _c("el-option", {
                            key: items.dictId,
                            attrs: {
                              label: items.dictName,
                              value: items.dictId,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c("el-date-picker", {
                    attrs: {
                      type: "daterange",
                      "picker-options": _vm.pickerOptions2,
                      "unlink-panels": "",
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                      align: "right",
                      format: "yyyy- MM- dd",
                      "value-format": "yyyy-MM-dd",
                    },
                    model: {
                      value: _vm.regionForm.time,
                      callback: function ($$v) {
                        _vm.$set(_vm.regionForm, "time", $$v)
                      },
                      expression: "regionForm.time",
                    },
                  }),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini" },
                      on: { click: _vm.refleshbigMap },
                    },
                    [_vm._v("刷新")]
                  ),
                ],
                1
              ),
            ]),
            _c("div", { attrs: { id: "china_map_box" } }, [
              _c("div", {
                staticStyle: { width: "70%", height: "500px" },
                attrs: { id: "china_map" },
              }),
            ]),
          ]),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.sexPopUp, "append-to-body": true, title: "" },
          on: {
            "update:visible": function ($event) {
              _vm.sexPopUp = $event
            },
          },
        },
        [
          _c("div", { staticClass: "dialog" }, [
            _c("div", { staticClass: "header dialogNav" }, [
              _c("p", [
                _c("span", { staticStyle: { "font-size": "15px" } }, [
                  _vm._v("性别"),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "top_right" },
                [
                  _c(
                    "div",
                    { staticClass: "selectTree" },
                    [
                      _c("treeselect", {
                        attrs: {
                          options: _vm.options,
                          "search-nested": "",
                          normalizer: _vm.normalizer,
                          noResultsText: "未找到",
                          placeholder: "请选择",
                        },
                        model: {
                          value: _vm.sexForm.colony,
                          callback: function ($$v) {
                            _vm.$set(_vm.sexForm, "colony", $$v)
                          },
                          expression: "sexForm.colony",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "picker_select" },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            clearable: "",
                            filterable: "",
                            placeholder: "请选择",
                          },
                          model: {
                            value: _vm.sexForm.salasType,
                            callback: function ($$v) {
                              _vm.$set(_vm.sexForm, "salasType", $$v)
                            },
                            expression: "sexForm.salasType",
                          },
                        },
                        _vm._l(_vm.statistic, function (items) {
                          return _c("el-option", {
                            key: items.dictId,
                            attrs: {
                              label: items.dictName,
                              value: items.dictId,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c("el-date-picker", {
                    attrs: {
                      type: "daterange",
                      "picker-options": _vm.pickerOptions2,
                      "unlink-panels": "",
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                      align: "right",
                      format: "yyyy- MM- dd",
                      "value-format": "yyyy-MM-dd",
                    },
                    model: {
                      value: _vm.sexForm.time,
                      callback: function ($$v) {
                        _vm.$set(_vm.sexForm, "time", $$v)
                      },
                      expression: "sexForm.time",
                    },
                  }),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini" },
                      on: { click: _vm.refleshsex },
                    },
                    [_vm._v("刷新")]
                  ),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "echartlinesex" }, [
              _c("div", {
                staticStyle: { width: "100%", height: "300px" },
                attrs: { id: "genderEcharts_Popup" },
              }),
            ]),
          ]),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.teamPopUp, "append-to-body": true, title: "" },
          on: {
            "update:visible": function ($event) {
              _vm.teamPopUp = $event
            },
          },
        },
        [
          _c("div", { staticClass: "dialog" }, [
            _c("div", { staticClass: "header dialogNav" }, [
              _c("p", [
                _c("span", { staticStyle: { "font-size": "15px" } }, [
                  _vm._v("部门排行榜"),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "top_right" },
                [
                  _c(
                    "div",
                    { staticClass: "selectTree" },
                    [
                      _c("treeselect", {
                        attrs: {
                          options: _vm.options,
                          "search-nested": "",
                          normalizer: _vm.normalizer,
                          multiple: true,
                          noResultsText: "未找到",
                          placeholder: "请选择",
                        },
                        model: {
                          value: _vm.departmentForm.colony,
                          callback: function ($$v) {
                            _vm.$set(_vm.departmentForm, "colony", $$v)
                          },
                          expression: "departmentForm.colony",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "picker_select" },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            clearable: "",
                            filterable: "",
                            placeholder: "请选择",
                          },
                          model: {
                            value: _vm.departmentForm.salasType,
                            callback: function ($$v) {
                              _vm.$set(_vm.departmentForm, "salasType", $$v)
                            },
                            expression: "departmentForm.salasType",
                          },
                        },
                        _vm._l(_vm.statistic, function (items) {
                          return _c("el-option", {
                            key: items.dictId,
                            attrs: {
                              label: items.dictName,
                              value: items.dictId,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c("el-date-picker", {
                    attrs: {
                      type: "daterange",
                      "picker-options": _vm.pickerOptions2,
                      "unlink-panels": "",
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                      align: "right",
                      format: "yyyy- MM- dd",
                      "value-format": "yyyy-MM-dd",
                    },
                    model: {
                      value: _vm.departmentForm.time,
                      callback: function ($$v) {
                        _vm.$set(_vm.departmentForm, "time", $$v)
                      },
                      expression: "departmentForm.time",
                    },
                  }),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini" },
                      on: { click: _vm.refleshSalasBig },
                    },
                    [_vm._v("刷新")]
                  ),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "group" }, [
              _c(
                "div",
                { staticClass: "checked" },
                [
                  _c(
                    "el-radio-group",
                    {
                      on: { change: _vm.changTu1 },
                      model: {
                        value: _vm.departmentForm.checkedTu,
                        callback: function ($$v) {
                          _vm.$set(_vm.departmentForm, "checkedTu", $$v)
                        },
                        expression: "departmentForm.checkedTu",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v("折线图"),
                      ]),
                      _c("el-radio", { attrs: { label: 2 } }, [
                        _vm._v("柱状图"),
                      ]),
                    ],
                    1
                  ),
                  _vm.departmentForm.checkedTu != 2
                    ? _c(
                        "el-radio-group",
                        {
                          on: { change: _vm.dayMothon1 },
                          model: {
                            value: _vm.departmentForm.checked,
                            callback: function ($$v) {
                              _vm.$set(_vm.departmentForm, "checked", $$v)
                            },
                            expression: "departmentForm.checked",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("按天展示"),
                          ]),
                          _c("el-radio", { attrs: { label: 2 } }, [
                            _vm._v("按月展示"),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c("div", { staticClass: "echart1" }, [
                _c("div", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.departmentForm.checkedTu == "1",
                      expression: "departmentForm.checkedTu == '1'",
                    },
                  ],
                  staticStyle: { width: "100%", height: "300px" },
                  attrs: { id: "teamEchart1" },
                }),
                _c("div", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.departmentForm.checkedTu == "2",
                      expression: "departmentForm.checkedTu == '2'",
                    },
                  ],
                  staticStyle: { width: "100%", height: "300px" },
                  attrs: { id: "teamEchart1ZZ" },
                }),
              ]),
            ]),
          ]),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.linePopUp, "append-to-body": true, title: "" },
          on: {
            "update:visible": function ($event) {
              _vm.linePopUp = $event
            },
          },
        },
        [
          _c("div", { staticClass: "dialog" }, [
            _c("div", { staticClass: "header dialogNav" }, [
              _c("p", [
                _c("span", { staticStyle: { "font-size": "15px" } }, [
                  _vm._v("入线方式"),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "top_right" },
                [
                  _c(
                    "div",
                    { staticClass: "selectTree" },
                    [
                      _c("treeselect", {
                        attrs: {
                          options: _vm.options,
                          "search-nested": "",
                          normalizer: _vm.normalizer,
                          noResultsText: "未找到",
                          placeholder: "请选择",
                        },
                        model: {
                          value: _vm.lineForm.colony,
                          callback: function ($$v) {
                            _vm.$set(_vm.lineForm, "colony", $$v)
                          },
                          expression: "lineForm.colony",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "picker_select" },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            clearable: "",
                            filterable: "",
                            placeholder: "请选择查询类型",
                          },
                          model: {
                            value: _vm.lineForm.salasType,
                            callback: function ($$v) {
                              _vm.$set(_vm.lineForm, "salasType", $$v)
                            },
                            expression: "lineForm.salasType",
                          },
                        },
                        _vm._l(_vm.statistic, function (items) {
                          return _c("el-option", {
                            key: items.dictId,
                            attrs: {
                              label: items.dictName,
                              value: items.dictId,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c("el-date-picker", {
                    attrs: {
                      type: "daterange",
                      "picker-options": _vm.pickerOptions2,
                      "unlink-panels": "",
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                      align: "right",
                      format: "yyyy- MM- dd",
                      "value-format": "yyyy-MM-dd",
                    },
                    model: {
                      value: _vm.lineForm.time,
                      callback: function ($$v) {
                        _vm.$set(_vm.lineForm, "time", $$v)
                      },
                      expression: "lineForm.time",
                    },
                  }),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini" },
                      on: { click: _vm.refleshline },
                    },
                    [_vm._v("刷新")]
                  ),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "teamechart" }, [
              _c("div", {
                staticStyle: { width: "100%", height: "300px" },
                attrs: { id: "lineEchart_popup" },
              }),
            ]),
          ]),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.agoPopUp, "append-to-body": true, title: "" },
          on: {
            "update:visible": function ($event) {
              _vm.agoPopUp = $event
            },
          },
        },
        [
          _c("div", { staticClass: "dialog" }, [
            _c("div", { staticClass: "header dialogNav" }, [
              _c("p", [
                _c("span", { staticStyle: { "font-size": "15px" } }, [
                  _vm._v("年龄"),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "top_right" },
                [
                  _c(
                    "div",
                    { staticClass: "selectTree" },
                    [
                      _c("treeselect", {
                        attrs: {
                          options: _vm.options,
                          "search-nested": "",
                          normalizer: _vm.normalizer,
                          noResultsText: "未找到",
                          placeholder: "请选择",
                        },
                        model: {
                          value: _vm.agoForm.colony,
                          callback: function ($$v) {
                            _vm.$set(_vm.agoForm, "colony", $$v)
                          },
                          expression: "agoForm.colony",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "picker_select" },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            clearable: "",
                            filterable: "",
                            placeholder: "请选择",
                          },
                          model: {
                            value: _vm.agoForm.salasType,
                            callback: function ($$v) {
                              _vm.$set(_vm.agoForm, "salasType", $$v)
                            },
                            expression: "agoForm.salasType",
                          },
                        },
                        _vm._l(_vm.statistic, function (items) {
                          return _c("el-option", {
                            key: items.dictId,
                            attrs: {
                              label: items.dictName,
                              value: items.dictId,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c("el-date-picker", {
                    attrs: {
                      type: "daterange",
                      "picker-options": _vm.pickerOptions2,
                      "unlink-panels": "",
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                      align: "right",
                      format: "yyyy- MM- dd",
                      "value-format": "yyyy-MM-dd",
                    },
                    model: {
                      value: _vm.agoForm.time,
                      callback: function ($$v) {
                        _vm.$set(_vm.agoForm, "time", $$v)
                      },
                      expression: "agoForm.time",
                    },
                  }),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini" },
                      on: { click: _vm.refleshAgo },
                    },
                    [_vm._v("刷新")]
                  ),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "teamechart" }, [
              _c("div", {
                staticStyle: { width: "100%", height: "300px" },
                attrs: { id: "agoEchart_popup" },
              }),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [_c("span", [_vm._v("数据看板")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [_c("span", [_vm._v("销售榜单")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [_c("span", [_vm._v("用户画像")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "echartline" }, [
      _c("div", {
        staticStyle: { width: "100%", height: "200px" },
        attrs: { id: "chartLineBox" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "echartline" }, [
      _c("div", {
        staticStyle: { width: "100%", height: "200px" },
        attrs: { id: "Incoming" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "echartline" }, [
      _c("div", {
        staticStyle: { width: "100%", height: "200px" },
        attrs: { id: "agesEcharts" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "echartline" }, [
      _c("div", {
        staticStyle: { width: "100%", height: "200px" },
        attrs: { id: "genderEcharts" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }